export function capitalize(str) {
    var substrings = str.split(' ');
    return substrings.map(function (word) { return "".concat(word.charAt(0).toUpperCase()).concat(word.substring(1).toLowerCase()); }).join(' ');
}
export function kebabCase() {
    var strings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        strings[_i] = arguments[_i];
    }
    var regX = /[^a-z\s]/gi;
    var substrings = strings.map(function (substring) {
        return String(substring)
            .toLowerCase()
            .replace(regX, '')
            .split(' ')
            .map(function (i) { return i.trim(); })
            .filter(function (i) { return !!i; })
            .join('-');
    });
    return substrings.join('-');
}
export function snakeCase() {
    var strings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        strings[_i] = arguments[_i];
    }
    var regX = /[^a-z\s]/gi;
    var substrings = strings.map(function (substring) {
        return String(substring)
            .toLowerCase()
            .replace(regX, '')
            .split(' ')
            .map(function (i) { return i.trim(); })
            .filter(function (i) { return !!i; })
            .join('_');
    });
    return substrings.join('_');
}
export function dePascalCase(str) {
    var regX = /([A-Z]+[a-z]+)/g;
    return str.replace(regX, '$& ').trim();
}
export function getPersonPlural(countValue) {
    var count = parseFloat(countValue);
    return "".concat(count, " ").concat(count === 1 ? 'Person' : 'People');
}
export function pluralise(str) {
    return str.endsWith('s') ? "".concat(str, "'") : "".concat(str, "'s");
}
export function isUpperCase(str) {
    return str === str.toUpperCase();
}
export function sentenceCase(str) {
    var substrings = str.toLowerCase().split(' ');
    substrings[0] = capitalize(substrings[0]);
    return substrings.join(' ');
}
export function intelligentSentenceCase(str) {
    str = String(str);
    if (isUpperCase(str))
        return str;
    else
        return sentenceCase(str);
}
